import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ComponentAccess } from '../../../../common/decorators/component-access.decorator';
import { CommonRoute } from '../../../../common/enums/common-route.enum';
import { LayoutService } from '../../../layout/service/app.layout.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  standalone: true,
  imports: [RouterLink, ButtonModule],
})
@ComponentAccess('NotFoundComponent')
export class NotFoundComponent {
  readonly layoutService = inject(LayoutService);
  readonly CommonRoute = CommonRoute;
}
